<template>
    <div class="messages">
        <div class="row">
            <div class="col-md-12">
                <router-link :to="{ name: 'messages.list'}" class="btn btn-warning"> <i class="fa fa-arrow-left"></i> Listeye Dön </router-link>
            </div>
            <div class="col-md-12">
                <div class="widget">
                    <div class="form-elements-sec">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="dorm">Yurt</label>
                                <input type="text" class="form-control custom-input" v-model="dorm" readonly>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="name">Ad Soyad</label>
                                <input type="text" class="form-control custom-input" v-model="name" readonly>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="email">E-posta</label>
                                <input type="text" class="form-control custom-input" v-model="email" readonly>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="phone">Telefon</label>
                                <input type="text" class="form-control custom-input" v-model="phone" readonly>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="message">Mesaj</label>
                                <textarea class="form-control custom-input" rows="10" v-model="message" readonly></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/layouts/Pagination'
    export default {
        components: { Pagination },
        data () {
            return {
                id: this.$route.params.id,
                api: 'messages/',
                dorm: '',
                name: '',
                email: '',
                phone: '',
                message: '',
            }
        },
        mounted () {
            this.getData()
        },
        methods: {
            getData() {
                this.$Progress.start()
                this.axios.get(this.api + this.id).then(response => {
                    this.name = response.data.name
                    this.email = response.data.email
                    this.phone = response.data.phone
                    this.dorm = response.data.dorm.name
                    this.message = response.data.message
                    this.$Progress.finish()
                })
            },
        },
    }
</script>

<style scoped>

</style>